module.exports = __webpack_public_path__ + "img/wallet-b.fc0b1628.svg";